import NeighborhoodPage from "@/components/NeighborhoodPage";

const JardimBotanico = () => (
  <NeighborhoodPage
    name="Jardim Botânico"
    slug="jardim-botanico"
    description="Cercado por verde, tranquilidade e gastronomia de primeira. Imóveis em Jardim Botânico combinam qualidade de vida, natureza e proximidade da Lagoa e do Leblon."
  />
);

export default JardimBotanico;
